import { RestaurantMainInfo, RestaurantSubInfo } from '~/features/info/RestaurantInfo'
import { sva } from '~/styled-system/css'
import type { RecipeVariantProps } from '~/styled-system/css'
import type { Props } from '../GuideRestaurantInfo'
import { mainShowTypes, subShowTypes } from '../GuideRestaurantInfo'

const style = sva({
  slots: ['root', 'title', 'body'],
  base: {
    root: {
      spaceY: '5',
    },
    title: {
      fontSize: '3xl',
      fontWeight: 'bold',
      lineHeight: 'snug',
    },
    body: {
      borderRadius: 'md',
      bgColor: 'gray.100',
      p: '6',
      divideY: 'thin',
      divideColor: 'gray.200',
      divideStyle: 'solid',
      dsY: '5',
    },
  },
  variants: {
    type: {
      modal: {
        root: {
          spaceY: '3',
        },
        title: {
          fontSize: 'xl',
        },
        body: {
          p: '0',
          bgColor: 'white',
        },
      },
    },
  },
})

export function GuideRestaurantInfo({
  restaurant,
  viewType = 'guide',
  type,
}: Props & RecipeVariantProps<typeof style>) {
  const classes = style({ type })
  return (
    <section className={classes.root}>
      <h2 className={classes.title}>店舗情報</h2>
      <div className={classes.body}>
        <RestaurantMainInfo restaurant={restaurant} showTypes={mainShowTypes(viewType)} />
        <RestaurantSubInfo restaurant={restaurant} showTypes={subShowTypes(viewType)} />
      </div>
    </section>
  )
}
